import React from 'react';
import {
  Label,
  Popup,
  Table
} from 'semantic-ui-react';

import { default as Commands } from '../lib/commands.js';

const HelpView = ({ command }) => {
  const Component = Commands[command.original] || Commands['default'];

  return (
    <Table celled compact definition inverted style={{'opacity': (command.flags !== 0 ? '1' : '0.25')}}>
      <Table.Header fullWidth>
        <Table.Row>
          <Table.HeaderCell style={{ "position": "relative" }}>
            {command.syntax}
            {Object.values(command.params).map((param, index) => <em>&nbsp;[{param.name}]</em>)}
            <div style={{
              "position": "absolute",
              "right": "10px",
              "top": "10px",
            }}>
              {command.flags === 3 ? (
                <Popup
                  trigger={<Label color='grey'>Subscribers Only</Label>}
                  content='This command is only available to subscribers of the channel.'
                  position='top right'
                />
              ) : ''}
              {command.is_alias ? (
                <Popup
                  trigger={<Label color='grey'>Alias</Label>}
                  content={`This command is an alias for the default command "${command.original}".`}
                  position='top right'
                />
              ) : ''}
              {command.is_custom ? (
                <Popup
                  trigger={<Label color='grey'>Custom</Label>}
                  content='This command is a custom command for this channel.'
                  position='top right'
                />
              ) : ''}
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Component description={command.description} />
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  )
};

export default HelpView;
